import Stat from 'Shared/components/Stat'
import './PageContainer.scoped.scss'

const statusMap = {
    'live': 'Live',
    'draft': 'Draft',
    'closed': 'Closed',
}

export default function StatsSection() {
  const { stats } = useSel((s) => s.dashboard)

  return (
    <div>
        <div className='box grid margin-top double no-side-padding' id='analytics'>
            <div className="stat-container">
            <Stat
                borderBottom={false}
                size={'vertical'}
                label={`Dashboard Targets`}
                primary={stats?.targetCount || 0}
            />
            </div>
            <div className="stat-container">
            <Stat
                borderBottom={false}
                size={'horizontal'}
                label={`Audience`}
                primary={stats?.audienceName || 0}
            />
            </div>
            <div className="stat-container">
            <Stat
                borderBottom={false}
                size={'vertical'}
                label={`Close Date`}
                primary={stats?.closeDate || 'Not set'}
            />
            </div>
        </div>
    </div>
  )
}
